export default "__VITE_ASSET__D6UraOa3__"